import { render, staticRenderFns } from "./FTabs.vue?vue&type=template&id=54d7155d&"
import script from "./FTabs.vue?vue&type=script&lang=js&"
export * from "./FTabs.vue?vue&type=script&lang=js&"
import style0 from "./FTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports